import { useRef, useState } from "react";
import { toast } from "sonner";

export const useDictation = (onText) => {
  const recRef = useRef(null);
  const [listening, setListening] = useState(false);

  const toggle = () => {
    if (listening) {
      recRef.current?.stop();
      setListening(false);
      return;
    }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      toast.error("Voice dictation isn't supported in this browser. Try Chrome.");
      return;
    }
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = false;
    rec.lang = "en-US";
    rec.onresult = (e) => {
      const t = Array.from(e.results).slice(e.resultIndex).map((r) => r[0].transcript).join(" ");
      if (t) onText(t.trim());
    };
    rec.onerror = () => setListening(false);
    rec.onend = () => setListening(false);
    recRef.current = rec;
    rec.start();
    setListening(true);
  };

  return { listening, toggle };
};
